import { Box, Grid, Typography, useTheme } from "@mui/material";
import TeamCarousel from "../components/About/Team";
import Jobs from "../components/Careers/Jobs";
import StayInLoop from "../components/StayInLoop";
import { IndiaFlag, USFlag } from "../constant";

export default function Careers() {
  const theme = useTheme();
  return (
    <>
      <Jobs />
      <TeamCarousel />
      <StayInLoop />
    </>
  );
}
